import React from 'react';
import { Col, Row } from 'reactstrap';
import { currencyFormater } from '../../utils/lib';

const RCTIInvoicesTotal = props => {
    const {subTotal, gst, gstAmount, totalRebateAmount, totalRebateAmountExcGst} = props;
    const calculatedGstAmount = (((subTotal||0) * (gst || 1)) /100).toFixed(2);
    return(
        <div className="full-width">
            <Row>
                <Col xs={2} md={4} lg={8}></Col>
                <Col xs={5} md={4} lg={2}>
                    Sub Total
                </Col>
                <Col xs={5} md={4} lg={2} className="text-right">
                    {currencyFormater(totalRebateAmountExcGst || subTotal)}
                </Col>
            </Row>
            <Row>
                <Col xs={2} md={4} lg={8}></Col>
                <Col xs={5} md={4} lg={2}>
                    GST
                </Col>
                <Col xs={5} md={4} lg={2} className="text-right">
                    {currencyFormater(gstAmount || calculatedGstAmount || 0)}
                </Col>
            </Row>
            <Row>
                <Col xs={2} md={4} lg={8}></Col>
                <Col xs={5} md={4} lg={2}>
                    Total
                </Col>
                <Col xs={5} md={4} lg={2} className="text-right">
                    {currencyFormater(totalRebateAmount ||  (Number(subTotal) + Number(calculatedGstAmount)))}
                </Col>
            </Row>
        </div>
    );
};

export default RCTIInvoicesTotal;